/** @format */

import { Component, HostBinding, input, OnInit, output } from '@angular/core';

import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { NgStyle } from '@angular/common';

@Component({
	selector: 'shared-totf-components-image-swatch',
	imports: [NgStyle],
	templateUrl: './image-swatch.component.html',
	styleUrl: './image-swatch.component.scss'
})
export class ImageSwatchComponent implements OnInit {
	@HostBinding('style.--colorSwatchRadius')
	color = input('');
	disabled = input(false);
	height = input('');
	imageSrc = input('');
	imageSwatchHoverDimension = input(false);
	isLazy = input(true);
	radius = input('');
	selected = input(false);
	width = input('');

	imageSwatchError = output<string>();

	swatchAriaLabel = '';

	ngOnInit(): void {
		this.swatchAriaLabel = this.color() ? `Color Option: ${this.color()}` : '';
	}

	// Emitting image source to product swatch component.
	// Product swatch will have additional info
	// which will be suitable for the rumrunner custom event
	emitImageError(event): void {
		event.target.src = DCSG_CONSTANTS.imageUnavailable;
		this.imageSwatchError.emit(this.imageSrc());
	}

	attributeValueClicked(elem): void {
		elem.blur();
	}
}
